import React from 'react'
import { FormattedMessage } from 'react-intl'

export const BUTTON_DIVIDE_PROFITS = (
    <FormattedMessage
        id="members_control_block.button.divide_profits"
        defaultMessage="Распределить казну"
    />
)

export const BUTTON_CHANGE_ROLE = (
    <FormattedMessage
        id="members_control_block.button.change_role"
        defaultMessage="Изменить должность"
    />
)

export const BUTTON_REMOVE_MEMBERS = (
    <FormattedMessage
        id="members_control_block.button.remove_members"
        defaultMessage="Исключить из клана"
    />
)



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersControlBlock/translations.js